// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"3e4de820d85311bdbee5","993":"37cb393e75573f5e770c"}[chunkId] + ".js");